import { ServiceState } from '@core/services/models/service.interface';
import { StateType } from '@core/interfaces/state-type.interface';

export const serviceStateLabel: Record<ServiceState, string> = {
    ACTIVE: 'Aktywna',
    INACTIVE: 'Nieaktywna',
    CREATING: 'W trakcie konfiguracji',
    PAUSED: 'Wstrzymana',
    NOT_PAID: 'Nieopłacona',
    INVALID_PAYMENT_METHOD: 'Błędna metoda płatności',
    NO_CAMPAIGNS: 'Brak kampanii',
    BLOCKED: 'Zablokowana',
    VERIFYING: 'W trakcie weryfikacji',
    WAITING_FOR_DATA: 'Oczekuje na dane',
    WAITING_FOR_PIXEL: 'Brak pixela'
};

export const serviceStateDescription: Record<ServiceState, string> = {
    ACTIVE: 'Usługa jest aktywna',
    INACTIVE: 'Usługa została wyłączona',
    CREATING: 'Usługa jest w trakcie konfiguracji',
    PAUSED: 'Usługa została wstrzymana',
    NOT_PAID: 'Usługa nie została opłacona',
    INVALID_PAYMENT_METHOD: 'Brak aktywnej metody płatności. Dodaj kartę w Centrum Płatności lub skontaktuj się z BOK',
    NO_CAMPAIGNS: 'Nie masz żadnej aktywnej kampanii',
    BLOCKED: 'Twoje konto oraz usługi zostały zablokowane',
    VERIFYING: 'Weryfikujemy Twoje zgłoszenie. Zajmuje to zazwyczaj do 2 dni roboczych',
    WAITING_FOR_DATA: 'Zbieramy dane niezbędne do uruchomienia usługi',
    WAITING_FOR_PIXEL: 'Pixel konwersji nie jest aktywny'
};

export const serviceStateColor: Record<ServiceState, StateType> = {
    ACTIVE: 'info',
    INACTIVE: 'default',
    CREATING: 'warning',
    PAUSED: 'warning',
    NOT_PAID: 'error',
    INVALID_PAYMENT_METHOD: 'warning',
    NO_CAMPAIGNS: 'warning',
    BLOCKED: 'error',
    VERIFYING: 'warning',
    WAITING_FOR_DATA: 'warning',
    WAITING_FOR_PIXEL: 'warning'
};
